// 租户Context接口
import { TenantContextProvider } from './types';
import defaultTenantContextProvider from './TenantContextDefaultImpl';

let tenantContextProvider = defaultTenantContextProvider;

export function setTenantContext(provider: TenantContextProvider) {
  tenantContextProvider = provider;
}

// 读取租户上下文
export function getTenantContext() {
  return tenantContextProvider.get();
}

// 清除缓存
export function clearTenantContextCache() {
  tenantContextProvider.clear();
}
